import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function Features() {
  const featuresList = ['No app required', 'Works with any smartphone', 'Private event gallery', 'Instant uploads', 'Messages & wishes from guests', 'Lifetime digital album'];
  return <section className="py-24 px-6 bg-dark-lighter border-y border-gold/10" data-id="element-54">
      <div className="max-w-5xl mx-auto" data-id="element-55">
        <FadeIn className="text-center mb-16" data-id="element-56">
          <h2 className="font-heading text-3xl md:text-4xl text-cream" data-id="element-57">
            Everything You Need for{' '}
            <span className="text-gold italic" data-id="element-58">Perfect Memories</span>
          </h2>
        </FadeIn>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-59">
          {featuresList.map((feature, index) => <FadeIn key={index} delay={0.1 * index} className="bg-dark p-6 rounded-xl border border-gold/5 hover:border-gold/30 transition-colors duration-300 flex items-center gap-4 group" data-id="element-60">
              <CheckCircle2 className="w-6 h-6 text-gold shrink-0 group-hover:scale-110 transition-transform duration-300" data-id="element-61" />
              <span className="text-cream-dark/90 text-lg" data-id="element-62">{feature}</span>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}